export default function() {
  //
  // The global script runs once before your library/app loads,
  // so you can do things like setting up a connection to an external service or configuring a library you are using.
  //

  const galleries = document.querySelectorAll(".covet-pics-gallery");

  galleries.forEach(gallery => {
    const widget = document.createElement("covet-pics-widget"),
      id = gallery.getAttribute("data-id"),
      shop = gallery.getAttribute("data-shop"),
      handle = gallery.getAttribute("data-product");

    if (id !== null) {
      widget.setAttribute("gallery-embed-id", id);
    } else if (shop !== null) {
      widget.setAttribute("shop", shop);
      if (handle !== null) { widget.setAttribute("data-product", handle); }
    } else {
      return true;
    }

    // Copy all attributes with "widget" prefix to new widget node
    let index, attribute;
    for (index = 0; index < gallery.attributes.length; ++index) {
      attribute = gallery.attributes[index];

      if (attribute.name.startsWith("widget")) {
        const name = attribute.name.replace(/^widget\-/, "");

        widget.setAttribute(name, attribute.value);
      }
    }

    gallery.appendChild(widget);
  });
}
